import { SignUp } from '@clerk/clerk-react';
import { css } from '@styled-system/css';

export const SignUpPage = () => {
  return (
    <div
      className={css({
        minHeight: '100vh',
        bg: 'background.primary',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        pt: '6rem',
      })}
    >
      <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
    </div>
  );
};
